<template>
  <div class="rating-container">
    <div class="rating-header">
      <span class="title">{{ $t('hm.title.rating') }}</span>
    </div>
    <HmPersonalInfo v-if="displayPersonalInfo"></HmPersonalInfo>
    <RatingInfo :dataInfo="ratingInfoData"></RatingInfo>
    <van-tabs
      v-model="active"
      class="rate-tabs"
      swipe-threshold="4"
      title-active-color="#757575"
      title-inactive-color="#cecece"
      swipeable
      animated
    >
      <van-tab :title="$t('hm.label.tab.rating.comments')" v-if="commentList.length > 0">
        <RatingComments :commentList="commentList"/>
        <NextStepButton @handelNextSetp="handelNextSetp" :showBackButton="false"/>
      </van-tab>
      <van-tab :title="$t('hm.label.tab.rating.resume')">
        <RatingResume :resumeData="resumeData" :jobId="ratingInfoData.job.id" :candidateId="ratingInfoData.candidate.id" @videoPop='handelVideoPop' />
        <NextStepButton @handelNextSetp="handelNextSetp" @handelBackSetp="handelBackSetp" :showBackButton="commentList.length > 0"/>
      </van-tab>
      <template v-if="reportUrl">
        <van-tab :title="$t('hm.label.tab.rating.report')">
          <iframe ref="iframe" @load="handelIframeLoad" class="report-iframe" :src="reportUrl"/>
          <NextStepButton @handelNextSetp="handelNextSetp" @handelBackSetp="handelBackSetp"/>
        </van-tab>
      </template>
      <template v-if="ratingList.length > 0">
        <van-tab :title="$t('hm.label.tab.rating.rating')">
          <RatingRate
            ref="ratingRate"
            :ratingList="ratingList"
            :readOnly="overall.rateStatus ? true: false"
            :showAnswer="true"
            @videoPop='handelVideoPop'/>
          <NextStepButton @handelNextSetp="handelRatingNextSetp" @handelBackSetp="handelBackSetp"/>
        </van-tab>
      </template>
      <van-tab :title="$t('hm.label.tab.rating.overall')">
        <RatingOverall ref="overall" :overall="overall" :isEdit="isEdit" :buttonOperate="overallOperate"/>
        <NextStepButton :nextButtonTitle="$t('hm.btn.submit')" @handelBackSetp="handelBackSetp" @handelNextSetp="handelRating"/>
      </van-tab>
    </van-tabs>
    <RectLoading v-show="showLoading"/>
    <van-popup v-model="popInfo.showVideoPop" closeable class="video-pop" @close='handelClosePop'>
      <div class="title">{{ popInfo.title }}</div>
      <video class="video" controls="controls" autoplay="autoplay" :src="popInfo.videoUrl"></video>
    </van-popup>
  </div>
</template>

<script>
import _ from 'lodash'
import HmPersonalInfo from './components/hmPersonalInfo.vue'
import RectLoading from '@/components/loading/rectLoading'
import RatingInfo from '../common/components/ratingInfo.vue'
import RatingComments from './components/comments.vue'
import RatingOverall from './components/overall.vue'
import RatingResume from './components/resume.vue'
import RatingRate from './components/rating.vue'
import NextStepButton from './components/nextStep.vue'
import { mapActions } from 'vuex'
import { deviceType } from '@/utils/common'
import { getHmToken } from '@/utils/hmToken'
import mixin from '../mixin'

const RATING_APPROVED = 2
const RATING_UNDERMINED = 0

export default {
  mixins: [mixin],
  components: {
    HmPersonalInfo,
    RatingInfo,
    RatingOverall,
    RatingRate,
    RatingResume,
    RatingComments,
    NextStepButton,
    RectLoading
  },
  props: {

  },
  data () {
    return {
      displayPersonalInfo: true,
      showLoading: false,
      active: 0,
      textSize: {
        minRows: 3,
        maxRows: 5
      },
      commentList: [],
      ratingList: [],
      overall: {
        rateScore: 0,
        rateStatus: null,
        status: null,
        comment: ''
      },
      overallOperate: {
        reject: {
          hidden: false,
          disabled: false,
          labelI18n: 'hm.label.rating.notRecommended',
          onButtonClick: this.handelRejectClick
        },
        padding: {
          hidden: true,
          disabled: false,
          labelI18n: 'hm.label.pending',
          onButtonClick: this.handelPaddingClick
        },
        approve: {
          hidden: false,
          disabled: false,
          labelI18n: 'hm.label.rating.Recommended',
          onButtonClick: this.handelApproveClick
        }
      },
      ratingInfoData: {
        company: {
          id: '',
          cn_name: '',
          name: '',
          logo_url: ''
        },
        job: {
          id: '',
          cn_title: '',
          title: ''
        },
        candidate: {
          id: '',
          name: '',
          show_assessment: false
        }
      },
      reportUrl: '',
      resumeData: {},
      popInfo: {
        showVideoPop: false,
        title: '',
        videoUrl: ''
      },
      btnSaveType: null,
      isEdit: false
    }
  },
  computed: {
    inviteCode () {
      return this.$route.params.inviteCode
    },
    verifyOverall () {
      return this.$refs.overall.verifyOverall()
    }
  },
  async created () {
    await this.initData()
  },
  beforeDestroy () {

  },
  methods: {
    ...mapActions('hm', ['getRatingInfoByInviteCode', 'saveRatingResultByInviteCode']),
    async initData () {
      this.showLoading = true
      try {
        const resp = await this.getRatingInfoByInviteCode(this.inviteCode)
        if (resp && resp.job) {
          this.ratingInfoData.job = resp.job
          this.ratingInfoData.company = resp.company
          this.ratingInfoData.candidate = resp.candidate
          this.commentList = _.filter(resp.applicant_comment_list, item => item.comment)
          this.ratingList = resp.question?.list || []
          this.overall = {
            rateScore: resp.total_rate,
            rateStatus: resp.total_rate ? 1 : 0,
            status: resp.status,
            comment: resp.comments
          }
          if (resp.total_rate) {
            this.isEdit = true
          } else {
            this.overall.status = resp.status === 1 ? null : resp.status
          }
          this.resumeData = resp.resume

          if (this.ratingInfoData.candidate.show_assessment) {
            const hmToken = getHmToken()
            this.reportUrl = this.$DjangoBaseUrl(`hm/report/${this.inviteCode}/?token=${hmToken}&show_download_icon_in_html=1&html=1`)
          }
        } else {
          this.$message.error(this.$t('hm.tips.invitcodeError'))
          setTimeout(() => {
            this.$router.push({ name: 'hmHomePage' })
          }, 1500)
        }
      } finally {
        this.showLoading = false
      }
    },
    handelRejectClick () {
      this.overall.rateStatus = 0
      this.btnSaveType = RATING_UNDERMINED
    },
    handelPaddingClick () {

    },
    handelApproveClick () {
      this.overall.rateStatus = 2
      this.btnSaveType = RATING_APPROVED
    },
    async verifyDateForRating () {
      const result = await this.verifyRating()
      if (!result) {
        this.active--
      }
      return this.verifyOverall && result
    },
    async handelRating () {
      const verifyResult = await this.verifyDateForRating()
      if (!verifyResult) {
        return
      }
      if (!_.includes([RATING_UNDERMINED, RATING_APPROVED], this.btnSaveType)) {
        return
      }
      const status = this.btnSaveType
      const params = {
        overall: {
          status: status,
          comment: this.overall.comment,
          rate_score: this.overall.rateScore
        },
        rating_list: this.ratingList
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.saveRatingResultByInviteCode({ inviteCode: this.inviteCode, params: params })
        if (resp) {
          this.$message.success(this.$t('hm.tips.ratingSuccess'))
          setTimeout(() => {
            this.$router.push({ name: 'hmHomePage' })
          }, 1500)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handelVideoPop (item) {
      this.popInfo.title = item.title
      this.popInfo.videoUrl = item.private_mp4_url
      this.popInfo.showVideoPop = true
    },
    handelClosePop () {
      this.popInfo.showVideoPop = false
      this.popInfo.title = ''
      this.popInfo.videoUrl = ''
    },
    async verifyRating () {
      if (this.ratingList.length === 0) {
        return true
      }
      if (!this.$refs.ratingRate) {
        let result = false
        await this.$nextTick()
        result = this.$refs.ratingRate?.verifyRatingList()
        if (result === undefined && this.ratingList.length > 0) {
          return false
        }
        return result
      }
      return this.$refs.ratingRate?.verifyRatingList()
    },
    handelNextSetp () {
      this.active++
      setTimeout(() => {
        document.querySelector('.rating-header .title').scrollIntoView({ block: 'center', behavior: 'smooth' })
      }, 300)
    },
    handelBackSetp () {
      this.active--
      setTimeout(() => {
        document.querySelector('.rating-header .title').scrollIntoView({ block: 'center', behavior: 'smooth' })
      }, 300)
    },
    async handelRatingNextSetp () {
      if (await this.verifyRating()) {
        this.active++
      }
    },
    async handelIframeLoad () {
      await new Promise(this.resetIframeCss)
    },
    resetIframeCss (resolve) {
      this.$nextTick(() => {
        const contentDocument = this.$refs.iframe.contentWindow.document
        if (!contentDocument) {
          return
        }
        const html = contentDocument.querySelector('html')
        if (!html) {
          setTimeout(() => this.resetIframeCss(resolve), 500)
          return
        }
        html.style.zoom = '0.33'
        html.style.width = '980px'
        html.style.margin = 'auto'
        if (deviceType.isiOS) {
          this.$refs.iframe.style.height = html.scrollHeight + 'px'
        } else {
          this.$refs.iframe.style.height = html.scrollHeight * 0.33 + 'px'
        }
        resolve()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.rating-container {
  background-color: #efefef;
  min-height: 100vh;
  padding-bottom: 20px;

  .rating-header {
    background-color: #0b0d1a;
    display: flex;
    justify-content: center;
    padding: 0 10%;

    .title {
        text-align: center;
        color: #FFFFFF;
        font-size: 18px;
        margin: 40px 0;
    }
  }

  ::v-deep.rate-tabs {
    .van-tabs__nav {
      background-color: #efefef;
      padding-left: 0;
      padding-right: 0;

      .van-tab {
        padding: 0;

        .van-tab__text {
          font-size: 15px;
        }

        &:not(:first-child) {
          margin-left: 15px;
        }
      }

      .van-tabs__line {
        height: 2px;
        background-color: #0096cc;
      }
    }

    .report-iframe {
      width: 98%;
      border: 0;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
    }
  }

  .rate-tabs {
    margin: 0 15px;
    ::v-deep {
      .van-tabs__nav {
        .van-tab__text {
          font-weight: bold;
        }

        .van-tabs__line {
          background-color: #0096cc;
        }
      }
    }

    .report-iframe {
      width: 100%;
      border: 0;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
    }
  }

  .video-pop {
    padding: 30px;

    .title {
      font-size: 14px;
      margin-bottom: 10px;
    }

    .video {
      height: 400px;
      width: 200px;
    }
  }
}
</style>
